import google, { mapContainerSize, mutators, verify } from "@churchofjesuschrist/maps-google";
import { css, defaultEmpty, proxy, proxyTimeout, removeListeners, removeUndefined, styleClass } from "@churchofjesuschrist/maps-utils";
import { getLowestZoomLevel } from "@churchofjesuschrist/maps-math";
let initialized = false;
const defaultStyles = [{
  elementType: "labels.icon",
  stylers: [{
    visibility: "off"
  }]
}];
class OverviewMap {
  constructor(mapDiv, options = {}) {
    if (!initialized) {
      verify();
      construct();
      initialized = true;
    }
    this.$div = mapDiv;
    this.setOptions(removeUndefined(options));
  }
}
const construct = () => {
  const mapClass = styleClass("google-overview")`
        width: 200%;
        height: 200%;
        position: absolute;
        top: -50%;
        left: -50%;
    `;
  Object.setPrototypeOf(OverviewMap.prototype, Object.assign(new google.maps.MVCObject(), mutators("mapTypeId", "map"), (() => {
    function onAdd() {
      let map = this.getMap();
      if (this.$map !== map && this.$div) {
        onRemove.call(this);
        this.$map = map;
        if (!this.$overview) {
          if (!this.getMapTypeId()) {
            this.setMapTypeId(map.getMapTypeId());
          }
          let mapDiv = document.createElement("div");
          mapDiv.className = mapClass;
          css(this.$div, {
            overflow: "hidden",
            position: "relative"
          });
          this.$div.appendChild(mapDiv);
          let mapOptions = removeUndefined({
            center: map.getCenter(),
            zoom: map.getZoom(),
            mapTypeId: this.getMapTypeId(),
            draggableCursor: this.get("draggableCursor"),
            styles: updateStyles.call(this),
            backgroundColor: true,
            disableDefaultUI: true,
            disableDoubleClickZoom: true,
            clickableIcons: false,
            scrollwheel: false
          });
          this.$overview = new google.maps.Map(mapDiv, mapOptions);
        }
        this.$listeners = [map.addListener("zoom_changed", proxy(updateZoom, this)), map.addListener("resize", proxy(onResize, this)), this.$overview.addListener("maptypeid_changed", proxy(verifyMapType, this)), this.$overview.addListener("styles_changed", proxy(updateStyles, this)), this.$overview.addListener("click", proxy(forwardClick, this))];
        this.$overview.bindTo("mapTypeId", this);
        this.$overview.bindTo("draggableCursor", this);
        onResize.call(this);
        updateZoom.call(this);
        google.maps.event.addListenerOnce(map, "tilesloaded", proxy(() => {
          let map = this.getMap();
          if (map) {
            onResize.call(this);
            this.$overview.setCenter(map.getCenter());
            updateZoom.call(this);
            this.$overview.bindTo("center", map);
          }
        }, this));
      }
    }
    function onRemove() {
      delete this.$map;
      if (this.$overview) {
        this.$overview.unbindAll();
      }
      if (removeListeners(this.$listeners)) {
        delete this.$listeners;
      }
    }
    function updateZoom() {
      proxyTimeout(() => {
        let map = this.getMap();
        if (map && this.$overview) {
          let bounds = map.getBounds(),
            size = mapContainerSize(this.$overview);
          if (bounds && size) {
            let zoom = getLowestZoomLevel(bounds.toJSON(), size);
            this.$overview.setZoom(zoom);
          }
        }
      }, this);
    }
    function updateStyles() {
      let map = this.getMap(),
        styles = [...defaultEmpty(map ? map.get("styles") : null, []), ...defaultStyles, ...defaultEmpty(this.get("styles"), [])];
      if (this.$overview) {
        this.$overview.set("styles", styles);
      }
      return styles;
    }
    function onResize() {
      if (this.$overview) {
        google.maps.event.trigger(this.$overview, "resize");
      }
    }
    function verifyMapType() {
      let mapTypeId = this.getMapTypeId(),
        map = this.getMap();
      if (this.$overview && !this.$overview.mapTypes[mapTypeId] && map) {
        let mapType = map.mapTypes[mapTypeId];
        if (mapType) {
          this.$overview.mapTypes.set(mapTypeId, mapType);
        }
      }
    }
    function forwardClick(event) {
      google.maps.event.trigger(this, "click", event);
    }
    return {
      getDiv: function () {
        return this.$div;
      },
      changed: function (key) {
        switch (key) {
          case "map":
            if (this.getMap()) {
              onAdd.call(this);
            } else {
              onRemove.call(this);
            }
            break;
          case "styles":
            updateStyles.call(this);
            break;
        }
      }
    };
  })()));
};
export default OverviewMap;